<div class="drawer-overlay display-phone" [class.open]="open" (click)="closeDrawer()"></div>

<button class="vertical-trigger display-phone" (click)="openDrawer()" aria-label="Ouvrir les filtres">
  <span>FILTRER</span>
</button>

<aside class="filter-container drawer-panel" [class.open]="open">
  
  <div class="entete-mobile display-phone">
    <button type="button" class="btn-retour" (click)="closeDrawer()">
      <i class="fa-solid fa-chevron-left"></i> Retour
    </button>
    <div class="header-pill">Filtres</div>
  </div>

  <div class="desktop-header hidden-phone">
    J'affine ma recherche
  </div>

  <div class="filters-body text-dark">

    <!-- Mini search bar contextuelle — filtre uniquement les produits de la page en cours -->
    <div class="filter separator">
      <div class="title">
        <i class="fa-solid fa-magnifying-glass fa-xl green me-2"></i>Recherche
      </div>
      <div class="search-input-wrapper">
        <input 
          type="text" 
          class="form-control"
          [formControl]="searchText"
          placeholder="Rechercher dans cette page..." 
        />
      </div>
    </div>
    
    <div class="filter separator">
      <div class="title">
        <i class="fad fa-box-taped fa-xl green me-2"></i>Disponibilité
      </div>
      <div class="stock-options">
        <div class="form-check form-switch mb-2">
          <input class="form-check-input green-switch" name="instock" type="checkbox" [(ngModel)]="filter.instock" id="filter-instock">
          <label class="form-check-label" for="filter-instock">En stock</label>
        </div>
        <div class="form-check form-switch">
          <input class="form-check-input green-switch" name="lowstock" type="checkbox" [(ngModel)]="filter.lowstock" id="filter-lowstock">
          <label class="form-check-label" for="filter-lowstock">Bientôt en rupture</label>
        </div>
      </div>
    </div>

    <div *ngIf="hasFilter('filter-players')" class="filter separator">
      <div class="title">
        <i class="fad fa-swords fa-xl green me-2"></i>Joueurs
      </div>
      <gob-range [title]="true" symbol="" [min]="1" [max]="18" [steps]="0" [minVal]="filter.pMin" [maxVal]="filter.pMax" (setVal)="setPlayer($event)"></gob-range>
    </div>

    <div *ngIf="hasFilter('filter-age')" class="filter separator">
      <div class="title">
        <i class="fad fa-cake-candles fa-xl green me-2"></i>Âge
      </div>
      <gob-range [title]="true" symbol="ans" [min]="1" [max]="18" [steps]="0" [minVal]="filter.yearMin" [maxVal]="filter.yearMax" (setVal)="setAge($event)"></gob-range>
    </div>

    <div *ngIf="hasFilter('filter-time')" class="filter separator">
      <div class="title">
        <i class="fad fa-timer fa-xl green me-2"></i>Durée
      </div>
      <gob-range [title]="true" symbol="min" [min]="1" [max]="300" [steps]="0" [minVal]="filter.dMin" [maxVal]="filter.dMax" (setVal)="setDuree($event)"></gob-range>
    </div>

    <div class="filter separator">
      <div class="title">
        <i class="fa-solid fa-euro-sign fa-xl green me-2"></i>Prix
      </div>
      <gob-range [title]="true" symbol="€" [min]="1" [max]="500" [steps]="0" [minVal]="filter.priceMin" [maxVal]="filter.priceMax" (setVal)="setPrice($event)"></gob-range>
    </div>

    <div *ngIf="hasFilter('filter-categ')" class="filter separator">
      <div class="title"><i class="fa-solid fa-layer-group fa-xl green me-2"></i>Catégorie</div>
      <select class="form-select" id="filter-categ" name="categ" [(ngModel)]="filter.categ">
        <option [ngValue]="undefined">Toutes les catégories</option>
        <option *ngFor="let categ of categs" [ngValue]="categ.ident">{{categ.name}}</option>
      </select>
    </div>

    <div *ngIf="hasFilter('filter-scateg')" class="filter separator">
      <div class="title"><i class="fa-solid fa-sitemap fa-xl green me-2"></i>Sous-catégorie</div>
      <select class="form-select" id="filter-scateg" name="scateg" [(ngModel)]="filter.scateg">
        <option [ngValue]="undefined">Toutes</option>
        <option *ngFor="let scateg of scategs" [ngValue]="scateg.ident">{{scateg.name}}</option>
      </select>
    </div>

    <div *ngIf="hasFilter('filter-gamme')" class="filter separator">
      <div class="title"><i class="fa-brands fa-d-and-d fa-xl green me-2"></i>Gamme</div>
      <select class="form-select" id="filter-gamme" name="gamme" [(ngModel)]="filter.gamme">
        <option [ngValue]="undefined">Toutes les gammes</option>
        <option *ngFor="let gamme of gammes" [ngValue]="gamme.ident">{{gamme.name}}</option>
      </select>
    </div>

    <div *ngIf="hasFilter('filter-marque')" class="filter separator">
      <div class="title"><i class="fa-solid fa-paintbrush fa-xl green me-2"></i>Éditeur</div>
      <select class="form-select" id="filter-marque" name="marque" [(ngModel)]="filter.marque">
        <option [ngValue]="undefined">Tous les éditeurs</option>
        <option *ngFor="let marque of marques" [ngValue]="marque.ident">{{marque.name}}</option>
      </select>
    </div>

    <div *ngIf="hasFilter('filter-tag')" class="filter separator">
      <div class="title"><i class="fa-solid fa-gears fa-xl green me-2"></i>Mécanique</div>
      <select class="form-select" id="filter-tag" name="tag" [(ngModel)]="filter.tag">
        <option [ngValue]="undefined">Toutes les mécaniques</option>
        <option *ngFor="let tag of tags" [ngValue]="tag.ident">{{tag.name}}</option>
      </select>
    </div>

    <div *ngIf="hasFilter('filter-news') || hasFilter('filter-promo')" class="filter separator">
      <div class="title"><i class="fa-solid fa-star fa-xl green me-2"></i>À ne pas manquer</div>
      <div class="stock-options">
        <div *ngIf="hasFilter('filter-news')" class="form-check form-switch mb-2">
          <input class="form-check-input green-switch" name="news" type="checkbox" [(ngModel)]="filter.news" id="filter-news">
          <label class="form-check-label" for="filter-news">Nouveautés</label>
        </div>
        <div *ngIf="hasFilter('filter-promo')" class="form-check form-switch">
          <input class="form-check-input green-switch" name="promo" type="checkbox" [(ngModel)]="filter.promo" id="filter-promo">
          <label class="form-check-label" for="filter-promo">Promotions</label>
        </div>
      </div>
    </div>

    <div class="action-buttons-wrapper">
      <button (click)="search()" class="btn btn-action btn-apply">
        Appliquer les filtres <i class="fa-solid fa-check ms-2"></i>
      </button>
      <button (click)="reset()" class="btn btn-action btn-reset">
        Réinitialiser <i class="fa-solid fa-arrow-rotate-left ms-2"></i>
      </button>
    </div>

  </div>
</aside>